import React from "react";

import { colors } from "@zapalacorp/tokens";

const UtilizationComponent: React.FC<{ data: number }> = ({ data }) => {
  const getColor = () => {
    if (data < 100) return colors.warning500;
    if (data === 100) return colors.success500;

    return colors.error500;
  };

  return (
    <div
      style={{
        width: "100%",
        fontFamily: "Manrope",
        fontWeight: 700,
        fontSize: "12px",
        color: getColor(),
        lineHeight: "16px",
        letterSpacing: "0.4px",
      }}
    >
      {data}%
    </div>
  );
};

export default UtilizationComponent;
